import styled from 'styled-components';

import { Button } from '../styles';

const SlidesList = styled('ul')`
	margin: 16px 0 0;
	padding: 0;
	list-style-type: none;
	user-select: none;

	li + li {
		margin-top: 6px;
	}
`;

const ButtonEditText = styled(Button)`
	margin-top: 12px;
`;

export {
	SlidesList,
	ButtonEditText,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SliderManager/styles.ts